import {
    getIPAddress,
    addIPAddress,
    updateIPAddress,
    fetchIPAddressById,
    getIPAddressCount
  } from "../../services/IPAddressService";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const IP_ADDRESS_LIST_INITIATED = "IP_ADDRESS_LIST_INITIATED";
  export const IP_ADDRESS_INITIATED = "IP_ADDRESS_INITIATED";
  export const IP_ADDRESS_LIST_LOADED = "IP_ADDRESS_LIST_LOADED";
  export const IP_ADDRESS_LOADED = "IP_ADDRESS_LOADED";
  export const IP_ADDRESS_FAILED = "IP_ADDRESS_FAILED";
  export const IP_ADDRESS_COUNT_INITIATED = "IP_ADDRESS_COUNT_INITIATED";
  export const IP_ADDRESS_COUNT_LOADED = "IP_ADDRESS_COUNT_LOADED";
  export const IP_ADDRESS_COUNT_FAILED  = "IP_ADDRESS_COUNT_FAILED";
  
  export const loadIPAddress = (getData) => {
    return (dispatch) => {
      dispatch({ type: IP_ADDRESS_LIST_INITIATED });
      getIPAddress(getData)
        .then((response) => {
          dispatch({ type: IP_ADDRESS_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: IP_ADDRESS_FAILED, payload: error.message });
        });
    };
  };

  export const loadIPAddressCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: IP_ADDRESS_COUNT_INITIATED });
      getIPAddressCount(getData)
        .then((response) => {
          dispatch({ type: IP_ADDRESS_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: IP_ADDRESS_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  export const getIPAddressById = (id) => {
    return (dispatch) => {
      dispatch({ type: IP_ADDRESS_INITIATED });
      return fetchIPAddressById(id)
        .then((response) => {
          dispatch({ type: IP_ADDRESS_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: IP_ADDRESS_FAILED, payload: formatError(error) });
        });
    };
  };
  
  export const saveIPAddressAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: IP_ADDRESS_INITIATED });
      const apiCall = isEdit ? updateIPAddress(id, data) : addIPAddress(data);
      return apiCall
        .then((response) => {
          formatSuccess('IP Address', response.data)
          if(!isEdit){
            setTimeout(()=>{
              navigate('/ip-whitelisted');
            },1000)
          }
          else{
            dispatch({ type: IP_ADDRESS_LOADED, payload: response.data.data });
          }
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: IP_ADDRESS_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: IP_ADDRESS_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };